module.exports = __webpack_public_path__ + "85acbea643517b32b1d080276a443f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chubb_us_2023_chart.png
// module id = 1655
// module chunks = 0